import { GRAVITY_WEBSITE_HANDOFF_QUERY_KEY } from './gravityWebsiteHandoffConstants.js';
import isGravityWebsiteHandoffId from './isGravityWebsiteHandoffId.js';

const readGravityWebsiteHandoffIdFromSearch = (search = '') => {
  const handoffId = String(new URLSearchParams(search || '').get(GRAVITY_WEBSITE_HANDOFF_QUERY_KEY) || '').trim();

  return isGravityWebsiteHandoffId(handoffId) ? handoffId : '';
};

export default readGravityWebsiteHandoffIdFromSearch;
